import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-auth-action-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <h2 mat-dialog-title>Требуется вход</h2>
    <div mat-dialog-content>
      <p>Для этого действия нужно войти в аккаунт.</p>
      @if (emails.length) {
        <div class="email-list">
          @for (email of emails; track email) {
            <div class="email-row">
              <button mat-stroked-button class="email-btn" (click)="login(email)">{{ email }}</button>
              <button mat-icon-button type="button" aria-label="Удалить аккаунт" (click)="remove(email)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          }
        </div>
      } @else {
        <p class="empty-state">Пользователей еще не зарегистрировано</p>
      }
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button (click)="close()">Отмена</button>
      <button mat-raised-button color="primary" (click)="login()">Другой аккаунт</button>
    </div>
  `,
  styles: [`.email-list{display:flex;flex-direction:column;gap:8px;margin-top:8px}.email-row{display:flex;align-items:center;gap:6px}.email-btn{flex:1;text-align:left;justify-content:flex-start}.empty-state{margin:8px 0 0;color:#666;font-size:14px}`],
})
export class AuthActionDialogComponent {
  emails: string[];

  constructor(
    private dialogRef: MatDialogRef<AuthActionDialogComponent>,
    private auth: AuthService,
    @Inject(MAT_DIALOG_DATA) data: { emails: string[] }
  ) {
    this.emails = data?.emails || [];
  }

  close() {
    this.dialogRef.close({ proceed: false });
  }

  login(email?: string) {
    this.dialogRef.close({ proceed: true, email });
  }

  remove(email: string) {
    this.auth.removeRecentLoginEmail(email);
    this.emails = this.emails.filter((e) => e !== email);
  }
}
